var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfidenceExplanation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 5,
    r: 5,
    transform: "rotate(90 37 5)",
    fill: "#758494"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "rotate(90 5 5)",
    fill: "#758494",
    fillOpacity: 0.05,
    stroke: "#758494"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 5,
    r: 4.5,
    transform: "rotate(90 21 5)",
    fill: "#758494",
    fillOpacity: 0.5,
    stroke: "#758494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidenceExplanation);
export default __webpack_public_path__ + "static/media/confidence_explanation.4065d4f91746da929936256b3103c566.svg";
export { ForwardRef as ReactComponent };